warning_show = false
$.fn.extend
  themesContainer: (options) ->
    input = 
      option1: "red"
    
    input = $.extend input, options

    # console.log settings.frames

    $(document).on 'click', '#createThemeThumbs', ->

        product_id = $(@).data('product_id')
        loading('Tvořím náhledy', [
          'Ještě chvíli...',
          'Už to bude...',
          'Ještě chvilinku strpení...',
          'Ještě maličko...',
          'Ještě pár vteřin...',
          'Kvalita chce klid a kafe...',
          'Ani Řím nepostavili za den...',
          'I Bůh tvořil svět sedm dní...',
          'Dokonalost potřebuje čas...',
          'Mistr tiskař si taky dává načas...',
          'Trpělivost růže přináší...',
          'Ještě pár bajtů do cíle...',
          'Data se srovnávají do latě...',
          'Sázej písmo, říkali... bude to sranda, říkali...',
          'Na dobré věci se čeká...',
          'Jeden pixel za druhým...',
          'Tohle by rozplakalo i procesor...',
          'V zákulisí to teď jiskří...',
          'Almost there... skoro!'
        ]);

        $.ajax(
          dataType: 'JSON'
          method: 'POST'
          data:
            product_id: product_id
          url: '/ajax/app/createThemeThumbs/'
        ).done (data) ->
          console.log data
          loading_stop()
        return false

    $(document).on 'click', '.change_theme', (e) ->

        console.log $(@).data('product_change')

        e.preventDefault()
        e.stopPropagation()

        $('.theme_cont').removeClass 'active'
        $(@).parent('.theme_cont').addClass 'active'



        if $(@).data('product_change')
          new_url = $(@).attr('href')
          await $.ajax(
            dataType: 'JSON'
            method: 'POST'
            data:
              app_url: window.location.pathname
            url: '/ajax/app/get_t/'
          ).done (data) ->
            new swal(
                title: data.t.app110
                text: data.t.app111
                icon: 'info'
                showCancelButton: true
                confirmButtonColor: '#3DC132'
                confirmButtonText: data.t.app67
                cancelButtonColor: '#5599FF'
                cancelButtonText: data.t.app68
                showCloseButton: true
              ).then (result) ->
                if !result.dismiss
                  window.location.href = new_url
                else
                  console.log 'tak nic'


        else
          output.change_theme($(@).data('theme'))

        return false



    container = $(@)
    
    output = {

      change_theme: (theme) ->

          $.ajax(
            dataType: 'JSON'
            method: 'POST'
            data:
              app_url: window.location.pathname
            url: '/ajax/app/get_t/'
          ).done (data) ->
              console.log data
              if !warning_show
                new swal(
                  title: data.t.app65
                  text: data.t.app66
                  icon: 'info'
                  showCancelButton: true
                  confirmButtonColor: '#3DC132'
                  confirmButtonText: data.t.app67
                  cancelButtonColor: '#5599FF'
                  cancelButtonText: data.t.app68
                  showCloseButton: true
                ).then (result) ->
                    if !result.dismiss
                      loading()
                      warning_show = true
                      $.ajax(
                        dataType: 'JSON'
                        method: 'POST'
                        data:
                          theme: theme
                          app_url: window.location.pathname
                        url: '/ajax/app/change_theme/'
                      ).done((data) ->
                        console.log data
                        loading_stop()
                        loadPage('', false)
                      ).fail (jqXHR, textStatus) ->
                        console.warn 'Error: ' + jqXHR.responseText
                        return
                    else
                      console.log 'saving'

                      # if result.dismiss == 'cancel'
                      #   loadPage('ulozit')
                    return 
              else

                loading()
                $.ajax(
                  dataType: 'JSON'
                  method: 'POST'
                  data:
                    theme: theme
                    app_url: window.location.pathname
                  url: '/ajax/app/change_theme/'
                ).done((data) ->
                  console.log data
                  loading_stop()
                  loadPage('', false)
                ).fail (jqXHR, textStatus) ->
                  console.warn 'Error: ' + jqXHR.responseText
                  return

          return 

        reload: () ->
            
            if $('#page_detail').length
                page = $('#page_detail').data 'page_number'
            else page = 0

            $.ajax(
              dataType: 'JSON'
              method: 'POST'
              url: '/ajax/app/themes_container/'
              data: 
                app_url: window.location.pathname
                selected_photo_product: $('#theme_selected_photo_product').val()
                # page: page
            ).done((data) ->
                hideLoader()
                container.html data.html_output
                # $('.scrollbar').scrollbar();
                
                # tooltip = new Tooltip
                #   theme: "dark"
                #   delay: 250
                

            ).fail (jqXHR, textStatus) ->
              console.warn 'Error: ' + jqXHR.responseText
              return
            return 


            

    }

    # output.reload()

    return output